import React from 'react';
import CommonDate from '../CommonDate';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum ESearchCondition {
  HAVE_PLACED_ANY_ORDER = 'HAVE_PLACED_ANY_ORDER',
  HAVE_NOT_PLACED_ANY_ORDER = 'HAVE_NOT_PLACED_ANY_ORDER',
}

const OrderDate = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const options = [
    {
      value: ESearchCondition.HAVE_PLACED_ANY_ORDER,
      label: getI18n('general.advancedFilters.orderDate.placeAnyOrder'),
    },
    {
      value: ESearchCondition.HAVE_NOT_PLACED_ANY_ORDER,
      label: getI18n('general.advancedFilters.orderDate.notPlacedAnyOrder'),
    },
  ];
  const {
    noStyle,
    selectName,
    daysName,
    policyName,
    singleDayName,
    dayRangeName,
    disabled,
  } = props;
  return (
    <CommonDate
      noStyle={noStyle}
      options={options}
      selectName={selectName}
      daysName={daysName}
      policyName={policyName}
      singleDayName={singleDayName}
      dayRangeName={dayRangeName}
      triggerSelectValue={[
        ESearchCondition.HAVE_PLACED_ANY_ORDER,
        ESearchCondition.HAVE_NOT_PLACED_ANY_ORDER,
      ]}
      selectPlaceholder={getI18n('general.orderDate.pleaseselectcondition')}
      disabled={disabled}
    />
  );
};
export default OrderDate;
